import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class PaymentLoanApplyApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'paymentLoanApply'
  }

}